import styled from 'styled-components';

/**
 * The shell: a fixed-width rail, then a column holding the topbar and the one
 * scrolling region. The page scrolls under the topbar rather than with it, so
 * the title and the user chip stay reachable on a long list.
 */

export const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  background: var(--canvas);
  overflow: hidden;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: var(--s5);

  &::-webkit-scrollbar {
    width: 11px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--line-strong);
    border-radius: var(--r-pill);
    border: 3px solid var(--canvas);
  }
`;
